import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

export interface ExportFormats {
  md: boolean;
  json?: boolean;
  pdf?: boolean; // 予約（未対応）
  csv?: boolean;
  csvEncoding?: 'utf8' | 'sjis';
}

export interface ExportResponse {
  success: boolean;
  downloadUrl: string;
  filePath: string;
  filename: string;
  pageCount: number;
}

export const exportSelectedPages = async (
  workspaceId: string,
  pageIds: string[],
  formats: ExportFormats
): Promise<ExportResponse> => {
  const fn = httpsCallable(functions, 'exportSelectedPagesFn');
  const res = await fn({ workspaceId, pageIds, formats });
  return res.data as ExportResponse;
};



